<template>
  <div>
    <div class="d-flex flex-wrap align-items-center gap-2">
      <span class="text-secondary small">1</span>
      <div class="flex-grow-1" style="min-width: 140px;">
        <select2
          v-model.trim="v$.unitConversion.unit_id.$model"
          :options="$parent.select2FormUnitConversion.options"
          :settings="$parent.select2FormUnitConversion.setting"
        />
      </div>
      <span class="text-secondary fw-bold">=</span>
      <input
        :id="'conversionFactor'+index"
        type="number"
        inputmode="decimal"
        v-model.trim="v$.unitConversion.conversion_factor.$model"
        class="form-control form-control-sm"
        style="max-width: 120px;"
        :placeholder="$t('Conversion Factor')"
      >
      <span class="text-secondary small">{{ $parent.unitName }}</span>
      <button
        type="button"
        @click="$parent.deleteUnit(index)"
        class="btn btn-sm btn-outline-danger ms-auto"
        :title="$t('Delete')"
        style="--bs-btn-padding-y: .2rem; --bs-btn-padding-x: .45rem;"
      >
        <i class="fa-solid fa-trash" />
      </button>
    </div>
    <div v-for="error of v$.unitConversion.unit_id.$errors"
      class="d-block invalid-feedback"
      :key="error.$uid"
    >
      {{ error.$message }}
    </div>
    <div v-for="error of v$.unitConversion.conversion_factor.$errors"
      class="d-block invalid-feedback"
      :key="error.$uid"
    >
      {{ error.$message }}
    </div>
  </div>
</template>

<script lang="js">
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-unit-conversion";
import numeral from 'numeral';
import Select2 from 'vue3-select2-component';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation
  },
  props: {
    unitConversion: {
      type: Object,
      default: [{
        unit_id: 0,
        conversion_factor: 0,
        is_purchase_unit: false
      }]
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
    }
  },
  components: {
    Select2
  },
  methods: {
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
  },
  async mounted() {},
  computed: {},
  watch: {}
}
</script>
